/* @flow */

import * as React from 'react';

import {Button} from '../../../button';

import './footer-add-buttons.css';

type Props = {|
    companyName: string,
    onAddCompany: ?() => any,
    onAddPeople: ?() => any,
    numSelectedPeople: number,
|};

export function FooterAddButtons(props: Props) {
    // TODO: Add confirmation popover

    let peopleText;
    if (props.numSelectedPeople === 1) {
        peopleText = '1 person';
    } else if (props.numSelectedPeople > 1) {
        peopleText = `${props.numSelectedPeople} people`;
    }

    const buttons = [];
    if (props.onAddCompany) {
        buttons.push(
            {
                key: 'add-company',
                label: (
                    <>
                        Add <strong>{props.companyName}</strong>
                        {peopleText ? ` & ${peopleText}` : ''}
                    </>
                ),
                // TODO: Open popover when clicked
                onClick: props.onAddCompany,
            },
            {
                key: 'add-company-and-lead',
                label: `Add and create new lead`,
                // TODO: Open popover when clicked
                onClick: props.onAddCompany,
            }
        );
    }

    if (props.onAddPeople && peopleText) {
        buttons.push({
            key: 'add-people',
            label: `Add ${peopleText}`,
            onClick: props.onAddPeople,
        });
    }

    return buttons.length ? (
        <div styleName='footer-add-buttons'>
            {buttons.map((button) => (
                <Button
                    key={button.key}
                    variant='save'
                    size='big'
                    isFullWidth={true}
                    onClick={button.onClick}
                >
                    {button.label}
                </Button>
            ))}
        </div>
    ) : null;
}
